<template>
  <b-modal class="change-comment-modal" :visible="show" @hide="() => this.$emit('close')" :title="choosedCommentUser.name"
    :ok-title="'Confirm' | translate" :cancel-title="'Cancel' | translate" hide-footer>
    <div>
      <input class="change-comment-input" v-if="isEditMode" type="text" v-model="choosedCommentUser.comment">

      <p class="change-comment-text" v-else>{{ choosedCommentUser.comment }}</p>
    </div>

    <div class="button-area">
      <button class="button edit" @click="switchEditMode">
        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="fi-rr-pencil" clip-path="url(#clip0_1187_589)">
            <path id="Vector"
              d="M15.7356 0.764814C15.2824 0.312279 14.6681 0.0581055 14.0276 0.0581055C13.3871 0.0581055 12.7728 0.312279 12.3196 0.764814L1.47692 11.6075C1.16642 11.9162 0.920229 12.2835 0.752586 12.688C0.584944 13.0925 0.499179 13.5263 0.500254 13.9641V15.3328C0.500254 15.5096 0.570492 15.6792 0.695516 15.8042C0.820541 15.9292 0.99011 15.9995 1.16692 15.9995H2.53559C2.97343 16.0007 3.40717 15.9151 3.81169 15.7476C4.21622 15.58 4.58349 15.3339 4.89225 15.0235L15.7356 4.18015C16.1879 3.72694 16.442 3.11279 16.442 2.47248C16.442 1.83217 16.1879 1.21802 15.7356 0.764814ZM3.94959 14.0808C3.57359 14.4543 3.06556 14.6646 2.53559 14.6661H1.83359V13.9641C1.83291 13.7014 1.88436 13.4412 1.98495 13.1984C2.08553 12.9557 2.23326 12.7354 2.41959 12.5501L10.6483 4.32148L12.1816 5.85481L3.94959 14.0808ZM14.7923 3.23748L13.1216 4.90881L11.5883 3.37881L13.2596 1.70748C13.3603 1.60702 13.4797 1.52737 13.6112 1.47309C13.7427 1.4188 13.8835 1.39094 14.0258 1.3911C14.168 1.39125 14.3088 1.41942 14.4401 1.47399C14.5715 1.52856 14.6908 1.60847 14.7913 1.70915C14.8917 1.80983 14.9714 1.92931 15.0256 2.06077C15.0799 2.19223 15.1078 2.3331 15.1076 2.47533C15.1075 2.61755 15.0793 2.75836 15.0247 2.8897C14.9702 3.02105 14.8903 3.14035 14.7896 3.24081L14.7923 3.23748Z"
              fill="#150722" />
          </g>
          <defs>
            <clipPath id="clip0_1187_589">
              <rect width="16" height="16" fill="white" transform="translate(0.5)" />
            </clipPath>
          </defs>
        </svg>

        {{ isEditMode ? 'Close' : 'Edit' | translate }}
      </button>

      <button class="button accept" @click="() => $emit('changeComment')">
        <div class="icon-spinner">
          <div v-if="choosedCommentUser.isCommentLoading" class="spinner-border spinner-border-sm" role="status" />
        </div>

        <a v-if="!choosedCommentUser.isCommentLoading">
          {{ 'Save' | translate }}
        </a>
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'modal-change-comment',

  props: ['show', 'choosedCommentUser'],

  data() {
    return {
      isEditMode: false,
    }
  },

  methods: {
    switchEditMode() {
      this.isEditMode = !this.isEditMode
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.change-comment-modal {
  position: relative;

  & .modal-body {
    display: block;
  }

  & .modal-header {
    padding: 15px 20px;
  }

  & .change-comment-input {
    background-color: #F1F6FA;
    border-radius: 8px;
    border: none;

    width: 100%;

    padding: 10px;
  }

  & .change-comment-text {
    padding: 10px;
    margin: 0;
  }

  & .button-area {
    text-align: right;
    padding: 10px;

    font-family: Montserrat !important;

    & .button {
      border-radius: 8px;
      border: none;
      outline: none;

      padding: 5px 10px;
      margin: 5px;

      font-size: 14px;
      font-weight: bold;

      &.edit {
        color: #374957;

        border-radius: 8px;
        border-color: #FFF;
        background: #FFF;
      }

      &.accept {
        color: #FFF;

        min-width: 100px;

        border-radius: 8px;
        border-color: #FAB610;
        background: #FAB610;
      }
    }
  }

  & button.close {
    position: absolute;

    top: 25px;
    right: 25px;

    background-color: #F1F2F5;
    padding: 4px 10px;

    border-radius: 50%;
  }
}
</style>